// extracted by mini-css-extract-plugin
export default {"top_header":"Review_top_header__FBX6C","table_stars":"Review_table_stars__B9LbH","table_image":"Review_table_image__Pk0Bd","img_box":"Review_img_box__fMw2x"};